import { Injectable, Sanitizer, SecurityContext } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlayerService } from './player.service';
import { toJSON } from 'css-convert-json';
import { DomSanitizer } from '@angular/platform-browser';
import { StatesService } from './states.service';
import { MotionPathService } from './motion-path.service';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  shapes = environment.shapes;
  public refreshContent = new BehaviorSubject(false);
  public refreshChart = new BehaviorSubject(null);
  constructor(
    private playerService: PlayerService,
    private _sanitizer: DomSanitizer,
    private statesService: StatesService,
    private motionPathService: MotionPathService
  ) {}

  getShape(component: any): string {
    let shapeId = component.content;
    let shapeSvg = '';

    if (shapeId == 'svg') {
      shapeSvg = component.data.svg;
    } else {
      this.shapes.forEach((shape: any) => {
        if (shape.id == shapeId) {
          shapeSvg = shape.svg;
        }
      });
    }

    if (component.data?.description) {
      shapeSvg = shapeSvg.replace(
        '<svg',
        '<svg aria-describedby="' + component.id + '-desc"'
      );
      shapeSvg = shapeSvg.replace(
        '</svg>',
        '<title>' + component.data?.description + '</title></svg>'
      );
      shapeSvg = shapeSvg.replace(
        '</svg>',
        '<desc id="' +
          component.id +
          '-desc">' +
          component.data?.description +
          '</desc></svg>'
      );
    }
    return shapeSvg;
  }

  getIcon(component: any): string {
    let iconSvg = component.data.svgPath;

    if (component.data?.description) {
      iconSvg = iconSvg.replace(
        '<svg',
        '<svg aria-describedby="' + component.id + '-desc"'
      );
      iconSvg = iconSvg.replace(
        '</svg>',
        '<title>' + component.data?.description + '</title></svg>'
      );
      iconSvg = iconSvg.replace(
        '</svg>',
        '<desc id="' +
          component.id +
          '-desc">' +
          component.data?.description +
          '</desc></svg>'
      );
    }
    return iconSvg;
  }

  getComponentStyle(
    component: any,
    mode: string = 'editor',
    scenario: any = null,
    choice?: any
  ) {
    let style: any;
    style = {};
    //style['width'] = component.width;
    //style['height'] = component.height;

    let componentStyle = JSON.parse(JSON.stringify(component.style));
    let componentStyleDefaults = JSON.parse(JSON.stringify(component.style));

    let currentState;
    let statesObject = component;
    if (choice) {
      statesObject = choice;
    }
    // determine the current state
    currentState = this.statesService.getComponentState(
      statesObject,
      component
    );

    if (component.currentState && !currentState) {
      currentState = this.getCurrentStateFromId(
        component,
        component.currentState
      );
    }

    // fix legacy hover styles
    if (
      component.states &&
      (component.type == 'button' || component.type == 'download' || choice)
    ) {
      // is a hover state defined?
      component.states.forEach((_state: any) => {
        if (_state.name == 'hover') {
          componentStyle.buttonHoverBg = this.buildGradientString(
            _state['style']['buttonBgGradient']
          )
            ? this.buildGradientString(_state['style']['buttonBgGradient'])
            : _state['style']['buttonBg'];

          componentStyle.buttonHoverBorder = _state['style']['buttonBorder'];
          componentStyle.buttonHoverOutline = _state['style']['buttonOutline'];
          componentStyle.buttonHoverColor = _state['style']['buttonColor'];
        }
      });
    }

    // don't apply the state to a choices block
    if (currentState) {
      for (const [key, value] of Object.entries(currentState['style'])) {
        if (
          key != 'buttonHoverBg' &&
          key != 'buttonHoverBorder' &&
          key != 'buttonHoverBorder' &&
          key != 'buttonHoverOutline' &&
          key != 'buttonHoverColor' &&
          key != 'hoverEffect'
        ) {
          componentStyle[key] = value;
        }
      }
      if (
        (component.type == 'button' || component.type == 'download') &&
        currentState['name'] == 'focus'
      ) {
        componentStyle.buttonHoverBg = currentState['style']['buttonBg'];
        componentStyle.buttonHoverBorder =
          currentState['style']['buttonBorder'];
        componentStyle.buttonHoverOutline =
          currentState['style']['buttonOutline'];
        componentStyle.buttonHoverColor = currentState['style']['buttonColor'];
      }

      if (
        component.type == 'choices' &&
        (currentState['name'] == 'hover' ||
          currentState['name'] == 'focus' ||
          currentState['name'] == 'visited' ||
          currentState['name'] == 'active')
      ) {
        componentStyle.choiceHoverBg = currentState['style']['choiceBg'];
        componentStyle.choiceHoverBorder =
          currentState['style']['choiceBorder'];
        componentStyle.choiceHoverOutline =
          currentState['style']['choiceOutline'];
        componentStyle.choiceHoverColor = currentState['style']['choiceColor'];
      }
      if (component.type == 'choices' && currentState['name'] == 'visited') {
        componentStyle.choiceVisitedBg = currentState['style']['choiceBg'];
        componentStyle.choiceVisitedBorder =
          currentState['style']['choiceBorder'];
        componentStyle.choiceVisitedColor =
          currentState['style']['choiceColor'];
      }
    }

    if (componentStyle.padding != undefined && !choice) {
      // is it split notation?
      let padding = '0';
      if (String(componentStyle.padding).indexOf(' ') >= 0) {
        padding = componentStyle.padding.replaceAll(' ', 'px ') + 'px';
      } else {
        padding = componentStyle.padding + 'px';
      }
      style['padding'] = padding;
      style['--ys-component-padding'] = padding;
    }
    if (componentStyle.bg && !choice) {
      style['background-color'] = componentStyle.bg;
      style['background'] = componentStyle.bg;
      style['--ys-component-bg'] = componentStyle.bg;
      style['--ys-component-bubbleBg'] = componentStyle.bg;
    }
    if (componentStyle.color) {
      style['color'] = componentStyle.color;
      style['--ys-component-color'] = componentStyle.color;
    }
    if (componentStyle.textColor) {
      style['color'] = componentStyle.textColor;
      style['--ys-text-color'] = componentStyle.textColor;
    }
    if (componentStyle.radius != undefined) {
      style['border-radius'] = componentStyle.radius + 'px';
      style['--ys-component-radius'] = componentStyle.radius + 'px';
    }

    if (component.type != 'choices') {
      if (componentStyle.textAlign) {
        style['text-align'] = componentStyle.textAlign;
        style['--ys-component-text-align'] = componentStyle.textAlign;
      }
      if (componentStyle.fontSize) {
        style['font-size'] = componentStyle.fontSize + '%';
        style['--ys-component-font-size'] = componentStyle.fontSize + '%';
      }
      if (componentStyle.fontWeight) {
        style['font-weight'] = componentStyle.fontWeight;
        style['--ys-component-font-weight'] = componentStyle.fontWeight;
      }
      if (componentStyle.lineHeight) {
        style['line-height'] = componentStyle.lineHeight + '%';
        style['--ys-component-line-height'] = componentStyle.lineHeight + '%';
      }
      if (componentStyle.letterSpacing) {
        style['letter-spacing'] =
          (componentStyle.letterSpacing - 100) / 100 + 'em';
        style['--ys-component-letter-spacing'] =
          (componentStyle.letterSpacing - 100) / 100 + 'em';
      }
    }
    if (componentStyle.opacity || componentStyle.opacity == 0) {
      style['opacity'] = componentStyle.opacity + '%';
    }
    if (componentStyle.blur) {
      style['filter'] = 'blur(' + componentStyle.blur + 'px)';
    }
    if (componentStyle.flexDirection) {
      style['--ys-component-flex-direction'] = componentStyle.flexDirection;
    }
    if (componentStyle.flexAlign) {
      style['--ys-component-flex-align'] = componentStyle.flexAlign;
    }
    if (componentStyle.flexJustify) {
      style['--ys-component-flex-justify'] = componentStyle.flexJustify;
      if (componentStyle.flexAlign == 'stretch') {
        //style['flex-grow'] = 1;
      }
    }

    if (component.style.flexItemWidth) {
      component.style.flexItemWidth.toString().slice(-1) == '%'
        ? (style['--ys-component-flex-item-width'] =
            component.style.flexItemWidth)
        : (style['--ys-component-flex-item-width'] =
            component.style.flexItemWidth + 'px');
      style['--ys-component-box-sizing'] = 'border-box';
      style['--ys-component-flex-flow'] = 'wrap';
    }
    if (component.style.flexItemHeight) {
      component.style.flexItemHeight.toString().slice(-1) == '%'
        ? (style['--ys-component-flex-item-height'] =
            component.style.flexItemHeight)
        : (style['--ys-component-flex-item-height'] =
            component.style.flexItemHeight + 'px');

      style['--ys-component-box-sizing'] = 'border-box';
      style['--ys-component-flex-flow'] = 'wrap';
    }

    if (componentStyle.textAlign) {
      style['--ys-component-text-align'] = componentStyle.textAlign;
    }
    // choice style vars

    if (componentStyle.choiceFontWeight) {
      style['--ys-component-choice-font-weight'] =
        componentStyle.choiceFontWeight;
    }
    if (componentStyle.choiceFontSize) {
      style['--ys-component-choice-font-scale'] =
        componentStyle.choiceFontSize + '%';
    }
    if (componentStyle.choiceLineHeight) {
      style['--ys-component-choice-line-height'] =
        componentStyle.choiceLineHeight + '%';
    }
    if (componentStyle.choiceLetterSpacing) {
      style['--ys-component-choice-letter-spacing'] =
        (componentStyle.choiceLetterSpacing - 100) / 100 + 'em';
    }

    if (componentStyle.choiceMargin) {
      style['--ys-component-choice-margin'] =
        componentStyle.choiceMargin + 'px';
    }
    if (componentStyle.choicePadding != undefined) {
      // is it split notation?
      let padding = '0';
      if (String(componentStyle.choicePadding).indexOf(' ') >= 0) {
        padding = componentStyle.choicePadding.replaceAll(' ', 'px ') + 'px';
      } else {
        padding = componentStyle.choicePadding + 'px';
      }
      style['--ys-component-choice-padding'] = padding;
    }
    if (componentStyle.choiceColor) {
      style['--ys-component-choice-color'] = componentStyle.choiceColor;
    }
    if (componentStyle.choiceBg) {
      style['--ys-component-choice-bg'] = componentStyle.choiceBg;
    }
    if (componentStyle.choiceRadius || componentStyle.choiceRadius == 0) {
      style['--ys-component-choice-radius'] =
        componentStyle.choiceRadius + 'px';
    }
    if (componentStyle.choiceOpacity) {
      style['--ys-component-choice-opacity'] =
        componentStyle.choiceOpacity + '%';
    }
    if (componentStyle.choiceBlur) {
      style['--ys-component-choice-blur'] = componentStyle.choiceBlur + 'px';
    }

    if (
      componentStyle.choiceBorder &&
      componentStyle.choiceBorder.width &&
      componentStyle.choiceBorder.style &&
      componentStyle.choiceBorder.color
    ) {
      style['--ys-component-choice-border'] =
        componentStyle.choiceBorder.width +
        'px ' +
        componentStyle.choiceBorder.style +
        ' ' +
        componentStyle.choiceBorder.color;
    }

    // choice hover
    if (componentStyle.choiceHoverColor) {
      style['--ys-component-choice-hover-color'] =
        componentStyle.choiceHoverColor;
    }
    if (componentStyle.choiceHoverBg) {
      style['--ys-component-choice-hover-bg'] = componentStyle.choiceHoverBg;
    }

    if (
      componentStyle.choiceHoverBorder &&
      componentStyle.choiceHoverBorder.width &&
      componentStyle.choiceHoverBorder.style &&
      componentStyle.choiceHoverBorder.color
    ) {
      style['--ys-component-choice-hover-border'] =
        componentStyle.choiceHoverBorder.width +
        'px ' +
        componentStyle.choiceHoverBorder.style +
        ' ' +
        componentStyle.choiceHoverBorder.color;
    }

    // choice visited
    if (component.style.choiceVisitedColor) {
      style['--ys-component-choice-visited-color'] =
        component.style.choiceVisitedColor;
    }
    if (component.style.choiceVisitedBg) {
      style['--ys-component-choice-visited-bg'] =
        component.style.choiceVisitedBg;
    }

    if (
      component.style.choiceVisitedBorder &&
      component.style.choiceVisitedBorder.width &&
      component.style.choiceVisitedBorder.style &&
      component.style.choiceVisitedBorder.color
    ) {
      style['--ys-component-choice-visited-border'] =
        component.style.choiceVisitedBorder.width +
        'px ' +
        component.style.choiceVisitedBorder.style +
        ' ' +
        component.style.choiceVisitedBorder.color;
    }

    //shadow
    if (componentStyle.choiceShadow && componentStyle.choiceShadow.offsetX) {
      style['--ys-component-choice-shadow'] =
        componentStyle.choiceShadow.offsetX +
        'px ' +
        componentStyle.choiceShadow.offsetY +
        'px ' +
        componentStyle.choiceShadow.blur +
        'px ' +
        componentStyle.choiceShadow.spread +
        'px ' +
        componentStyle.choiceShadow.color;
    }

    if (componentStyle.fill) {
      style['--ys-component-fill'] = componentStyle.fill;
    }

    // fonts...
    if (componentStyle.font) {
      switch (componentStyle.font) {
        case 'body':
          style['font-family'] = 'var(--ys-font-base)';
          break;
        case 'sans':
          style['font-family'] = 'var(--ys-font-sans)';
          break;
        case 'serif':
          style['font-family'] = 'var(--ys-font-serif)';
          break;
        case 'heading':
          style['font-family'] = 'var(--ys-font-heading)';
          break;
        case 'mono':
          style['font-family'] = 'var(--ys-font-mono)';
          break;
        case 'script':
          style['font-family'] = 'var(--ys-font-script)';
          break;
        case 'custom':
          // load the custom font!
          style['font-family'] = componentStyle.fontFamily;
          break;
      }
    }

    // font input
    if (componentStyle.fontInput) {
      switch (componentStyle.fontInput) {
        case 'body':
          style['--ys-input-font'] = 'var(--ys-font-base)';
          break;
        case 'sans':
          style['--ys-input-font'] = 'var(--ys-font-sans)';
          break;
        case 'serif':
          style['--ys-input-font'] = 'var(--ys-font-serif)';
          break;
        case 'heading':
          style['--ys-input-font'] = 'var(--ys-font-heading)';
          break;
        case 'mono':
          style['--ys-input-font'] = 'var(--ys-font-mono)';
          break;
        case 'script':
          style['--ys-input-font'] = 'var(--ys-font-script)';
          break;
        case 'custom':
          // load the custom font!
          style['--ys-input-font'] = componentStyle.fontFamilyInput;
          break;
      }
    }

    // font question
    if (componentStyle.fontQuestion) {
      switch (componentStyle.fontQuestion) {
        case 'body':
          style['--ys-question-font'] = 'var(--ys-font-base)';
          break;
        case 'sans':
          style['--ys-question-font'] = 'var(--ys-font-sans)';
          break;
        case 'serif':
          style['--ys-question-font'] = 'var(--ys-font-serif)';
          break;
        case 'heading':
          style['--ys-question-font'] = 'var(--ys-font-heading)';
          break;
        case 'mono':
          style['--ys-question-font'] = 'var(--ys-font-mono)';
          break;
        case 'script':
          style['--ys-question-font'] = 'var(--ys-font-script)';
          break;
        case 'custom':
          // load the custom font!
          style['--ys-question-font'] = componentStyle.fontFamilyQuestion;
          break;
      }
    }

    // font answer
    if (componentStyle.fontAnswer) {
      switch (componentStyle.fontAnswer) {
        case 'body':
          style['--ys-answer-font'] = 'var(--ys-font-base)';
          break;
        case 'sans':
          style['--ys-answer-font'] = 'var(--ys-font-sans)';
          break;
        case 'serif':
          style['--ys-answer-font'] = 'var(--ys-font-serif)';
          break;
        case 'heading':
          style['--ys-answer-font'] = 'var(--ys-font-heading)';
          break;
        case 'mono':
          style['--ys-answer-font'] = 'var(--ys-font-mono)';
          break;
        case 'script':
          style['--ys-answer-font'] = 'var(--ys-font-script)';
          break;
        case 'custom':
          // load the custom font!
          style['--ys-answer-font'] = componentStyle.fontFamilyAnswer;
          break;
      }
    }

    if (componentStyle.inputFontSize != undefined) {
      style['--ys-input-font-size'] = componentStyle.inputFontSize + '%';
    }
    if (componentStyle.inputRadius != undefined) {
      style['--ys-input-radius'] = componentStyle.inputRadius + 'px';
    }

    if (componentStyle.inputPadding) {
      if (componentStyle.inputPadding != undefined) {
        // is it split notation?
        let padding = '0';
        if (String(componentStyle.inputPadding).indexOf(' ') >= 0) {
          padding = componentStyle.inputPadding.replaceAll(' ', 'px ') + 'px';
        } else {
          padding = componentStyle.inputPadding + 'px';
        }
        style['--ys-input-padding'] = padding;
      }
    }

    // font label
    if (componentStyle.font) {
      switch (componentStyle.font) {
        case 'body':
          style['--ys-label-font'] = 'var(--ys-font-base)';
          break;
        case 'sans':
          style['--ys-label-font'] = 'var(--ys-font-sans)';
          break;
        case 'serif':
          style['--ys-label-font'] = 'var(--ys-font-serif)';
          break;
        case 'heading':
          style['--ys-label-font'] = 'var(--ys-font-heading)';
          break;
        case 'mono':
          style['--ys-label-font'] = 'var(--ys-font-mono)';
          break;
        case 'script':
          style['--ys-label-font'] = 'var(--ys-font-script)';
          break;
        case 'custom':
          // load the custom font!
          style['--ys-label-font'] = componentStyle.fontFamily;
          break;
      }
    }

    //outline
    if (
      componentStyle.outline &&
      componentStyle.outline.width &&
      componentStyle.outline.style &&
      componentStyle.outline.color
    ) {
      style['--ys-component-outline'] =
        componentStyle.outline.width +
        'px ' +
        componentStyle.outline.style +
        ' ' +
        componentStyle.outline.color;
    }

    //shadow
    if (
      component.type == 'button' &&
      scenario.style?.buttonShadow &&
      scenario.style?.buttonShadow?.offsetX
    ) {
      style['--ys-component-shadow'] =
        scenario.style.buttonShadow.offsetX +
        'px ' +
        scenario.style.buttonShadow.offsetY +
        'px ' +
        scenario.style.buttonShadow.blur +
        'px ' +
        scenario.style.buttonShadow.spread +
        'px ' +
        scenario.style.buttonShadow.color;
    }
    if (componentStyle.shadow && componentStyle.shadow.offsetX) {
      style['--ys-component-shadow'] =
        componentStyle.shadow.offsetX +
        'px ' +
        componentStyle.shadow.offsetY +
        'px ' +
        componentStyle.shadow.blur +
        'px ' +
        componentStyle.shadow.spread +
        'px ' +
        componentStyle.shadow.color;
    }

    //text shadow
    if (componentStyle.textShadow && componentStyle.textShadow.offsetX) {
      style['--ys-component-text-shadow'] =
        componentStyle.textShadow.offsetX +
        'px ' +
        componentStyle.textShadow.offsetY +
        'px ' +
        componentStyle.textShadow.blur +
        'px ' +
        componentStyle.textShadow.color;

      style['--ys-component-svg-shadow'] =
        'drop-shadow(' +
        componentStyle.textShadow.offsetX +
        'px ' +
        componentStyle.textShadow.offsetY +
        'px ' +
        componentStyle.textShadow.blur +
        'px ' +
        componentStyle.textShadow.color +
        ')';
    }

    // svg stroke?
    if (componentStyle.strokeWidth && componentStyle.strokeColor) {
      style['stroke'] = componentStyle.strokeColor;

      if (component.type == 'shape') {
        style['stroke-width'] = +componentStyle.strokeWidth / 10 + 'px';
      } else {
        style['stroke-width'] = +componentStyle.strokeWidth + 'px';
      }

      style['stroke-linejoin'] = 'round';
      style['paint-order'] = 'stroke';
    }

    if (mode == 'player' || mode == 'editor') {
      // choices?
      if (
        component.type == 'choices' &&
        scenario.style.choiceAnimation &&
        !componentStyle.animationIn
      ) {
        if (scenario.style.choiceAnimation.animationIn) {
          if (typeof scenario.style.choiceAnimation.animationIn == 'string') {
            style['--animate-duration'] =
              scenario.style.choiceAnimation.animationInSpeed + 's';
            style['--animate-delay'] =
              scenario.style.choiceAnimation.animationInDelay + 's';

            if (scenario.style.choiceAnimation.animationInRepeat) {
              if (
                scenario.style.choiceAnimation.animationInRepeat !== 'infinite'
              ) {
                style['--animate-repeat'] =
                  +scenario.style.choiceAnimation.animationInRepeat;
              }
            }
          } else {
            style['--animate-duration'] =
              scenario.style.choiceAnimation.animationIn.speed + 's';
            style['--animate-delay'] =
              scenario.style.choiceAnimation.animationIn.delay + 's';

            if (scenario.style.choiceAnimation.animationIn.repeat) {
              if (
                scenario.style.choiceAnimation.animationIn.repeat !== 'infinite'
              ) {
                style['--animate-repeat'] =
                  +scenario.style.choiceAnimation.animationIn.repeat;
              }
            }
          }
        }
      }

      // animation // new style!
      if (component.animationIn) {
        if (typeof component.animationIn == 'string') {
          style['--animate-duration'] = component.animationInSpeed + 's';
          style['--animate-delay'] = component.animationInDelay + 's';

          if (component.animationInRepeat) {
            if (component.animationInRepeat !== 'infinite') {
              style['--animate-repeat'] = +component.animationInRepeat;
            }
          }
        } else {
          if (component.animationIn.name != '') {
            style['--animate-duration'] = component.animationIn.speed + 's';
            style['--animate-delay'] = component.animationIn.delay + 's';

            if (component.animationIn.repeat) {
              if (component.animationIn.repeat !== 'infinite') {
                style['--animate-repeat'] = +component.animationIn.repeat;
              }
            }
          } else if (
            component.animationDuring &&
            component.animationDuring.name != ''
          ) {
            style['--animate-duration'] = component.animationDuring.speed + 's';
            style['--animate-delay'] = component.animationDuring.delay + 's';

            if (component.animationDuring.repeat) {
              if (component.animationDuring.repeat !== 'infinite') {
                style['--animate-repeat'] = +component.animationDuring.repeat;
              }
            }
          }
        }
      }

      if (component.hidden && mode == 'player') {
        style['display'] = 'none';
      }
    }

    // chat
    if (componentStyle.bubbleBg) {
      style['--ys-component-bubbleBg'] = componentStyle.bubbleBg;
    }
    if (componentStyle.bubbleColor) {
      style['--ys-component-bubbleColor'] = componentStyle.bubbleColor;
    }

    if (componentStyle.optionBubbleBg) {
      style['--ys-component-optionBubbleBg'] = componentStyle.optionBubbleBg;
    }
    if (componentStyle.optionBubbleColor) {
      style['--ys-component-optionBubbleColor'] =
        componentStyle.optionBubbleColor;
    }
    if (componentStyle.avatarRadius != undefined) {
      style['--ys-component-avatarRadius'] = componentStyle.avatarRadius + 'px';
    }

    if (componentStyle.avatarPosition) {
      style['--ys-component-avatar-position'] = componentStyle.avatarPosition;
    }

    if (componentStyle.chatPosition) {
      style['--ys-component-chat-position'] = componentStyle.chatPosition;
    }
    if (componentStyle.dividerColor) {
      style['--ys-component-divider-color'] = componentStyle.dividerColor;
    }

    // buttons

    if (componentStyle.buttonPadding) {
      if (componentStyle.buttonPadding != undefined) {
        // is it split notation?
        let padding = '0';
        if (String(componentStyle.buttonPadding).indexOf(' ') >= 0) {
          padding = componentStyle.buttonPadding.replaceAll(' ', 'px ') + 'px';
        } else {
          padding = componentStyle.buttonPadding + 'px';
        }
        style['--ys-component-button-padding'] = padding;
      }
    }

    if (componentStyle.buttonFontSize) {
      style['--ys-component-button-font-size'] =
        componentStyle.buttonFontSize + '%';
    }

    if (componentStyle.buttonFontSize) {
      style['--ys-component-button-font-size'] =
        componentStyle.buttonFontSize + '%';
    }

    if (componentStyle.buttonLetterSpacing) {
      style['--ys-component-button-letter-spacing'] =
        (componentStyle.buttonLetterSpacing - 100) / 100 + 'em';
    }

    if (componentStyle.buttonRadius != undefined) {
      style['--ys-component-button-radius'] =
        componentStyle.buttonRadius + 'px';
    }
    if (componentStyle.textAlign) {
      style['--ys-component-button-align'] = componentStyle.textAlign;
    }

    if (componentStyle.buttonBg) {
      style['--ys-component-button-bg'] = componentStyle.buttonBg;
    }

    if (
      componentStyle.buttonBgGradient &&
      componentStyle.buttonBgGradient.settings &&
      componentStyle.buttonBgGradient.settings.type
    ) {
      let bgString = this.buildGradientString(componentStyle.buttonBgGradient);
      style['--ys-component-button-bg'] = bgString;
    }

    if (componentStyle.buttonBorder && componentStyle.buttonBorder.width) {
      style['--ys-component-button-border'] =
        componentStyle.buttonBorder.width +
        'px ' +
        componentStyle.buttonBorder.style +
        ' ' +
        componentStyle.buttonBorder.color;
    }

    if (componentStyle.buttonOutline) {
      style['--ys-component-button-outline'] =
        componentStyle.buttonOutline.width +
        'px ' +
        componentStyle.buttonOutline.style +
        ' ' +
        componentStyle.buttonOutline.color;
    }
    if (componentStyle.buttonColor) {
      style['--ys-component-button-color'] = componentStyle.buttonColor;
    }
    if (componentStyle.buttonHoverBg) {
      style['--ys-component-button-hover-bg'] = componentStyle.buttonHoverBg;
    }
    if (
      componentStyle.buttonHoverBorder &&
      componentStyle.buttonHoverBorder.width
    ) {
      style['--ys-component-button-hover-border'] =
        componentStyle.buttonHoverBorder.width +
        'px ' +
        componentStyle.buttonHoverBorder.style +
        ' ' +
        componentStyle.buttonHoverBorder.color;
    }
    if (componentStyle.buttonHoverOutline) {
      style['--ys-component-button-hover-outline'] =
        componentStyle.buttonHoverOutline.width +
        'px ' +
        componentStyle.buttonHoverOutline.style +
        ' ' +
        componentStyle.buttonHoverOutline.color;
    }
    if (componentStyle.buttonHoverColor) {
      style['--ys-component-button-hover-color'] =
        componentStyle.buttonHoverColor;
    }

    if (componentStyle.gridCols) {
      style['--ys-component-grid-cols'] =
        'repeat(' + componentStyle.gridCols + ', 1fr)';
    }
    if (componentStyle.gridGap) {
      style['--ys-component-grid-gap'] = componentStyle.gridGap + 'px';
    }

    //

    // inputs

    if (componentStyle.inputColor) {
      style['--ys-input-color'] = componentStyle.inputColor;
    }
    if (componentStyle.inputBg) {
      style['--ys-input-bg'] = componentStyle.inputBg;
    }
    if (componentStyle.inputPlaceholder) {
      style['--ys-input-placeholder'] = componentStyle.inputPlaceholder;
    }
    if (componentStyle.inputFocus) {
      style['--ys-input-focus'] = componentStyle.inputFocus;
    }
    if (componentStyle.textColor) {
      style['--ys-label-color'] = componentStyle.textColor;
    }

    // quiz
    if (componentStyle.answerBg) {
      style['--ys-component-answer-bg'] = componentStyle.answerBg;
    }
    if (componentStyle.answerBgHover) {
      style['--ys-component-answer-bg-hover'] = componentStyle.answerBgHover;
    } else {
      if (scenario?.style?.primaryColor) {
        style['--ys-component-answer-bg-hover'] = scenario.style.primaryColor;
      }
    }
    if (componentStyle.answer) {
      style['--ys-component-answer'] = componentStyle.answer;
    }
    if (componentStyle.answerHover) {
      style['--ys-component-answer-hover'] = componentStyle.answerHover;
    }
    if (componentStyle.answerCorrectColor) {
      style['--ys-component-answer-color-correct'] =
        componentStyle.answerCorrectColor;
    }
    if (componentStyle.answerCorrectBg) {
      style['--ys-component-answer-bg-correct'] =
        componentStyle.answerCorrectBg;
    }
    if (componentStyle.answerIncorrectColor) {
      style['--ys-component-answer-color-incorrect'] =
        componentStyle.answerIncorrectColor;
    }
    if (componentStyle.answerIncorrectBg) {
      style['--ys-component-answer-bg-incorrect'] =
        componentStyle.answerIncorrectBg;
    }

    // tables

    if (componentStyle.thBg) {
      style['--ys-component-th-bg-color'] = componentStyle.thBg;
    }
    if (componentStyle.thText) {
      style['--ys-component-th-color'] = componentStyle.thText;
    }
    if (componentStyle.trBg) {
      style['--ys-component-tr-bg-color'] = componentStyle.trBg;
    }
    if (componentStyle.trText) {
      style['--ys-component-tr-color'] = componentStyle.trText;
    }
    if (componentStyle.trAltBg) {
      style['--ys-component-tr-alt-bg-color'] = componentStyle.trAltBg;
    }

    // hotspot
    if (componentStyle.iconColor) {
      style['--ys-component-icon-color'] = componentStyle.iconColor;
    }
    if (componentStyle.iconBg) {
      style['--ys-component-icon-bg'] = componentStyle.iconBg;
    }
    if (componentStyle.iconFontSize) {
      style['--ys-component-icon-size'] = componentStyle.iconFontSize + '%';
    }

    // custom css
    if (componentStyle.css) {
      try {
        let componentCss = toJSON(componentStyle.css).attributes;
        for (let key in componentCss) {
          if (CSS.supports(key, componentCss[key])) {
            style[key] = componentCss[key];
          }
        }
      } catch (error: any) {}
    }

    let customCss = '';
    if (componentStyle.cssAfter) {
      try {
        let componentCss = toJSON(componentStyle.cssAfter).attributes;
        var componentAfterCss = '';
        for (let key in componentCss) {
          if (CSS.supports(key, componentCss[key])) {
            componentAfterCss += key + ':' + componentCss[key] + ';';
          }
        }
        // now this is a bit naighty.  Add css to the head here...
        // remove the old
        customCss =
          '#component-ys-' +
          component.id +
          '::after, #component-' +
          component.id +
          '::after{' +
          componentAfterCss +
          '}';
      } catch (error: any) {}
    }

    if (componentStyle.cssBefore) {
      try {
        let componentCss = toJSON(componentStyle.cssBefore).attributes;
        var componentBeforeCss = '';
        for (let key in componentCss) {
          if (CSS.supports(key, componentCss[key])) {
            componentBeforeCss += key + ':' + componentCss[key] + ';';
          }
        }
        // now this is a bit naighty.  Add css to the head here...
        // remove the old
        customCss +=
          '#component-ys-' +
          component.id +
          '::before, #component-' +
          component.id +
          '::before{' +
          componentBeforeCss +
          '}';
      } catch (error: any) {}
    }

    if (componentStyle.cssHover) {
      try {
        let componentCss = toJSON(componentStyle.cssHover).attributes;
        var componentBeforeCss = '';
        for (let key in componentCss) {
          if (CSS.supports(key, componentCss[key])) {
            componentBeforeCss += key + ':' + componentCss[key] + ';';
          }
        }
        // now this is a bit naighty.  Add css to the head here...
        // remove the old
        customCss +=
          '#component-ys-' +
          component.id +
          ':hover, #component-' +
          component.id +
          ':hover{' +
          componentBeforeCss +
          '}';
      } catch (error: any) {}
    }

    if (customCss) {
      var elem = document.querySelector('#customCss' + component.id);
      if (elem?.textContent != customCss) {
        elem?.parentNode?.removeChild(elem);
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');

        style.appendChild(document.createTextNode(customCss));
        style.setAttribute('id', 'customCss' + component.id);
        head.appendChild(style);
      }
    }

    // gradients

    if (
      componentStyle.bgGradient &&
      componentStyle.bgGradient.settings &&
      componentStyle.bgGradient.settings.type
    ) {
      let bgString = this.buildGradientString(componentStyle.bgGradient);

      style.background = bgString;
    }

    // pick

    if (componentStyle.itemTextColor) {
      style['--ys-component-pick-item-text-color'] =
        componentStyle.itemTextColor;
    }
    if (componentStyle.itemBg) {
      style['--ys-component-pick-item-bg-color'] = componentStyle.itemBg;
    }
    if (componentStyle.itemHoverTextColor) {
      style['--ys-component-pick-item-hover-text-color'] =
        componentStyle.itemHoverTextColor;
    }
    if (componentStyle.itemHoverBg) {
      style['--ys-component-pick-item-hover-bg-color'] =
        componentStyle.itemHoverBg;
    }
    if (componentStyle.itemPickedTextColor) {
      style['--ys-component-pick-item-picked-text-color'] =
        componentStyle.itemPickedTextColor;
    }
    if (componentStyle.itemPickedBg) {
      style['--ys-component-pick-item-picked-bg-color'] =
        componentStyle.itemPickedBg;
    }
    if (
      componentStyle.itemPickedOutline &&
      componentStyle.itemPickedOutline.width &&
      componentStyle.itemPickedOutline.style &&
      componentStyle.itemPickedOutline.color
    ) {
      style['--ys-component-pick-item-picked-outline'] =
        componentStyle.itemPickedOutline.width +
        'px ' +
        componentStyle.itemPickedOutline.style +
        ' ' +
        componentStyle.itemPickedOutline.color;
    }

    if (componentStyle.transition) {
      style['--ys-component-transition'] = componentStyle.transition;
    }

    // does it have an on pressed action?
    if (
      (component.data &&
        component.data.actions &&
        component.data.actions.length > 0) ||
      component.interactivity?.popover?.template?.trigger ||
      component.interactivity?.window?.trigger
    ) {
      let hasPress = false;
      component.data.actions.forEach((action: any) => {
        action.events.forEach((event: any, eIndex: number) => {
          if (event.id == 'onPress') {
            hasPress = true;
          }
        });
      });

      if (
        component.interactivity?.popover?.template?.trigger == 'click' ||
        component.interactivity?.popover?.template?.trigger == 'dblclick' ||
        component.interactivity?.window?.trigger == 'click' ||
        component.interactivity?.window?.trigger == 'dblclick'
      ) {
        hasPress = true;
      }

      if (hasPress) {
        style['cursor'] = 'pointer';
      }
    }
    if (componentStyle.overflow) {
      style['--ys-component-overflow'] = componentStyle.overflow;
    }

    return style;
  }

  getComponentClass(component: any, mode = 'editor', scenario: any) {
    // console.log('component class' + Date.now() );
    let className;
    if (component.style.class) {
      className = component.style.class;
    }
    if (component.style.subClass) {
      className += ' ' + component.style.subClass;
    }
    // animated?
    if (
      component.type == 'choices' &&
      scenario.style.choiceAnimation &&
      !component.style.animationIn
    ) {
      if (scenario.style.choiceAnimation.animationIn) {
        if (typeof scenario.style.choiceAnimation.animationIn == 'string') {
          className +=
            ' animate__animated animate__delay-1s animate__' +
            scenario.style.choiceAnimation.animationIn;

          if (scenario.style.choiceAnimation.animationInRepeat) {
            if (
              scenario.style.choiceAnimation.animationInRepeat == 'infinite'
            ) {
              className += ' animate__infinite';
            } else {
              className += ' animate__repeat-1';
            }
          }
        } else {
          className +=
            ' animate__animated animate__delay-1s animate__' +
            scenario.style.choiceAnimation.animationIn.name;

          if (scenario.style.choiceAnimation.animationIn.repeat) {
            if (
              scenario.style.choiceAnimation.animationIn.repeat == 'infinite'
            ) {
              className += ' animate__infinite';
            } else {
              className += ' animate__repeat-1';
            }
          }
        }
      }
    }

    if (component.animationIn) {
      if (typeof component.animationIn == 'string') {
        className +=
          ' animate__animated animate__delay-1s animate__' +
          component.animationIn;

        if (component.animationInRepeat) {
          if (component.animationInRepeat == 'infinite') {
            className += ' animate__infinite';
          } else {
            className += ' animate__repeat-1';
          }
        }
      } else {
        // is there a name?
        if (component.animationIn.name != '') {
          className +=
            ' animate__animated animate__delay-1s animate__' +
            component.animationIn.name;

          if (component.animationIn.repeat) {
            if (component.animationIn.repeat == 'infinite') {
              className += ' animate__infinite';
            } else {
              className += ' animate__repeat-1';
            }
          }
        } else if (
          component.animationDuring &&
          component.animationDuring?.name != ''
        ) {
          className +=
            ' animate__animated animate__delay-1s animate__' +
            component.animationDuring.name;

          if (component.animationDuring.repeat) {
            if (component.animationDuring.repeat == 'infinite') {
              className += ' animate__infinite';
            } else {
              className += ' animate__repeat-1';
            }
          }
        }
      }
    }

    if (mode == 'player' && component.type != 'choices') {
      if (component.style.hoverEffect) {
        className += ' ' + component.style.hoverEffect.name;
      }
    }

    return className;
  }

  getEditorComponentWrapStyle(
    component: any,
    activeComponent?: any,
    motionPath?: any
  ) {
    let style: any;
    style = {};

    let componentStyle = JSON.parse(JSON.stringify(component.style));
    let componentStyleDefaults = JSON.parse(JSON.stringify(component.style));

    let currentState;
    // determine the current state
    if (component?.activeStates?.length > 0) {
      let currentStateName = '';
      // what is the order?
      if (component.activeStates.includes('dragging')) {
        currentStateName = 'dragging';
      } else if (component.activeStates.includes('active')) {
        currentStateName = 'active';
      } else if (component.activeStates.includes('hover')) {
        currentStateName = 'hover';
      } else if (component.activeStates.includes('focus')) {
        currentStateName = 'focus';
      }
      if (currentStateName) {
        component?.states?.forEach((_state: any) => {
          if (_state.name == currentStateName) {
            currentState = _state;
          }
        });
      }
    }
    if (component.currentState && !currentState) {
      currentState = this.getCurrentStateFromId(
        component,
        component.currentState
      );
    }
    if (currentState) {
      for (const [key, value] of Object.entries(currentState['style'])) {
        componentStyle[key] = value;
      }
    }

    let rotate = componentStyle.rotate;
    if (
      !componentStyle.rotate &&
      component.transform &&
      component.transform.rotate
    ) {
      rotate = component.transform.rotate;
    }

    style['transform'] = '';
    if (rotate) {
      if (!activeComponent) {
        style['transform'] = 'rotate(' + rotate + 'deg) ';
      } else {
        if (activeComponent.id != component.id) {
          style['transform'] = 'rotate(' + rotate + 'deg) ';
        }
      }
    }

    if (componentStyle?.flip?.h) {
      style['transform'] += 'scaleX(-1)';
    }

    if (componentStyle?.flip?.v) {
      style['transform'] += 'scaleY(-1)';
    }

    if (componentStyle?.zIndex) {
      style['z-index'] = componentStyle.zIndex;
    }

    if (
      component.type == 'image' &&
      componentStyle.shadow &&
      componentStyle.shadow.offsetX
    ) {
      style['--ys-component-shadow'] =
        componentStyle.shadow.offsetX +
        'px ' +
        componentStyle.shadow.offsetY +
        'px ' +
        componentStyle.shadow.blur +
        'px ' +
        componentStyle.shadow.spread +
        'px ' +
        componentStyle.shadow.color;

      style['--ys-component-drop-shadow'] =
        componentStyle.shadow.offsetX +
        'px ' +
        componentStyle.shadow.offsetY +
        'px ' +
        componentStyle.shadow.blur +
        'px ' +
        componentStyle.shadow.color;
    }

    if (
      motionPath == component.id &&
      component.motionPath &&
      component.motionPath?.type
    ) {
      let path = '';
      switch (component.motionPath?.type) {
        case 'custom':
        default:
          path = this.motionPathService.drawPath(
            component,
            'motionPath',
            'component-ys-' + component.id,
            true
          );
          break;
        case 'circle':
          path = this.motionPathService.circlePath(
            component,
            'motionPath',
            'component-ys-' + component.id,
            true
          );
          break;
      }

      style['offset-path'] = 'path("' + path + '")';

      let maintainEnd = '';
      if (component.motionPath.maintainEnd == 1) {
        maintainEnd = 'forwards';
      }
      let direction = component.motionPath.direction
        ? component.motionPath.direction
        : 'normal';

      let easing = component.motionPath.easing;
      if (easing == 'none') {
        easing = '';
        style['animation-timing-function'] = 'unset';
      }
      style['animation'] =
        'move ' +
        component.motionPath.speed +
        's ' +
        (motionPath == component.id ? '1' : component.motionPath.repeat) +
        ' ' +
        maintainEnd +
        '  ' +
        direction +
        ' ' +
        easing +
        '';

      if (component.motionPath.delay) {
        style['animation-delay'] =
          motionPath == component.id ? '0' : component.motionPath.delay + 's';
      }
      if (component.motionPath.rotateToPath != 1) {
        style['offset-rotate'] = '0deg';
      }
    }

    return style;
  }

  getComponentWrapStyle(component: any) {
    let style: any;
    style = {};

    let componentStyle = JSON.parse(JSON.stringify(component.style));
    let componentStyleDefaults = JSON.parse(JSON.stringify(component.style));

    let currentState;
    // determine the current state
    if (component?.activeStates?.length > 0) {
      let currentStateName = '';
      // what is the order?
      if (component.activeStates.includes('dragging')) {
        currentStateName = 'dragging';
      } else if (component.activeStates.includes('active')) {
        currentStateName = 'active';
      } else if (component.activeStates.includes('hover')) {
        currentStateName = 'hover';
      } else if (component.activeStates.includes('focus')) {
        currentStateName = 'focus';
      }
      if (currentStateName) {
        component?.states?.forEach((_state: any) => {
          if (_state.name == currentStateName) {
            currentState = _state;
          }
        });
      }
    }
    if (component.currentState && !currentState) {
      currentState = this.getCurrentStateFromId(
        component,
        component.currentState
      );
    }
    if (currentState) {
      for (const [key, value] of Object.entries(currentState['style'])) {
        componentStyle[key] = value;
      }
    }

    style['transform'] = '';
    'translate3d(' + component.pos.x + 'px, ' + component.pos.y + 'px ,0)';

    let rotate = componentStyle.rotate;
    if (
      !componentStyle.rotate &&
      component.transform &&
      component.transform.rotate
    ) {
      rotate = component.transform.rotate;
    }
    if (rotate) {
      style['transform'] += ' rotate(' + rotate + 'deg)';
    }

    if (componentStyle?.flip?.h) {
      style['transform'] += ' scaleX(-1)';
    }

    if (componentStyle?.flip?.v) {
      style['transform'] += ' scaleY(-1)';
    }
    if (componentStyle.zIndex) {
      //style['z-index'] = componentStyle.zIndex;
    }

    style['width'] = component.width + 'px';
    style['height'] = component.height + 'px';

    /* if (componentStyle.display) {
      style['display'] = componentStyle.display;
    }*/

    // transition
    if (componentStyle.transition) {
      style['--ys-component-transition'] = componentStyle.transition;
    }

    if (componentStyle.shadow && componentStyle.shadow.offsetX) {
      style['--ys-component-drop-shadow'] =
        componentStyle.shadow.offsetX +
        'px ' +
        componentStyle.shadow.offsetY +
        'px ' +
        componentStyle.shadow.blur +
        'px ' +
        componentStyle.shadow.color;
    }
    return style;
  }

  getComponentContainerStyle(component: any, playMotionPath?: any) {
    let style: any;
    style = {};

    let componentStyle = JSON.parse(JSON.stringify(component.style));
    let componentStyleDefaults = JSON.parse(JSON.stringify(component.style));

    // motion path?
    if (component.motionPath && component.motionPath?.type) {
      let path = '';
      switch (component.motionPath?.type) {
        case 'custom':
        default:
          path = this.motionPathService.drawPath(
            component,
            'motionPath',
            'component-ys-' + component.id,
            true
          );
          break;
        case 'circle':
          path = this.motionPathService.circlePath(
            component,
            'motionPath',
            'component-ys-' + component.id,
            true
          );
          break;
      }

      style['offset-path'] = 'path("' + path + '")';

      let maintainEnd = '';
      if (component.motionPath.maintainEnd == 1) {
        maintainEnd = 'forwards';
      }
      let direction = component.motionPath.direction
        ? component.motionPath.direction
        : 'normal';

      let easing = component.motionPath.easing;
      if (easing == 'none') {
        easing = '';
        style['animation-timing-function'] = 'unset';
      }
      style['animation'] =
        'move ' +
        component.motionPath.speed +
        's ' +
        (playMotionPath?.indexOf(component.id) > -1
          ? component.motionPath.repeat
          : component.motionPath.repeat) +
        ' ' +
        maintainEnd +
        '  ' +
        direction +
        ' ' +
        easing +
        '';

      if (component.motionPath.delay) {
        style['animation-delay'] =
          playMotionPath?.indexOf(component.id) > -1
            ? '0'
            : component.motionPath.delay + 's';
      }
      if (component.motionPath.rotateToPath != 1) {
        style['offset-rotate'] = '0deg';
      }
    }

    // does it need to have pointer events?
    if (component.type == 'block') {
      let needsPointer = false;
      let pointerEvents = ['onPress', 'onHover'];
      component?.data?.actions?.forEach((action: any) => {
        action?.events?.forEach((event: any) => {
          if (pointerEvents.indexOf(event.id) !== -1) {
            needsPointer = true;
          }
        });
      });
      // does it have interactions?
     /* if (component?.interactivity?.popover) {
        needsPointer = true;
      }
      if (component?.interactivity?.window) {
        needsPointer = true;
      }
      if (component?.interactivity?.tooltip) {
        needsPointer = true;
      }*/
      if (!needsPointer) {
        style['pointer-events'] = 'none';
      }
    }

    return style;
  }

  getChoiceStyle(component: any) {
    let style: any;
    style = {};
    //style['width'] = component.width;
    //style['height'] = component.height;

    if (component.style.padding != undefined) {
      style['padding'] = component.style.padding + 'px';
    }
    if (component.style.choiceBg) {
      style['background-color'] = component.style.choiceBg;
    }
    if (component.style.color) {
      style['color'] = component.style.color;
    }
    if (component.style.radius != undefined) {
      style['border-radius'] = component.style.radius + 'px';
    }

    if (component.style.textAlign) {
      style['text-align'] = component.style.textAlign;
    }

    if (component.style.choiceFontWeight) {
      style['--ys-component-choice-font-weight'] =
        component.style.choiceFontWeight + '%';
    }
    if (component.style.choiceFontSize) {
      style['--ys-component-choice-text-scale'] =
        component.style.choiceFontSize + '%';
    }
    if (component.style.choiceLineHeight) {
      style['--ys-component-choice-line-height'] =
        component.style.choiceLineHeight + '%';
    }
    if (component.style.choiceLetterSpacing) {
      style['--ys-component-choice-letter-spacing'] =
        (component.style.choiceLetterSpacing - 100) / 100 + 'em';
    }
    if (component.style.opacity || component.style.opacity == 0) {
      style['opacity'] = component.style.opacity + '%';
    }
    if (component.style.blur) {
      style['filter'] = 'blur(' + component.style.blur + 'px)';
    }

    return style;
  }
  getChoiceClass(component: any, choice?: any) {
    let className;

    if (component.style.choiceStyle) {
      className = component.style.choiceStyle;
    }
    if (component.style.choiceStyleSubClass) {
      className += ' ' + component.style.choiceStyleSubClass;
    }
    if (component.style.hoverEffect) {
      className += ' animate__animated ' + component.style.hoverEffect.name;
    }

    if (choice) {
      if (this.playerService.getHasTakenChoice(choice.choice_id)) {
        className += ' visited';
      }
    }
    return className;
  }

  getCanvasStyle(content: any, scenarioStyle: any, canvasSize?: any) {
    let style: any;
    style = {};
    if (content && content.canvas) {
      if (!content.canvas.style) {
        content.canvas.style = {};
      }
      if (content.canvas.style.bg) {
        style['background-color'] = content.canvas.style.bg;
      } else {
        if (scenarioStyle.bg) {
          style['background-color'] = scenarioStyle.bg;
        }
      }

      if (content.canvas.style.bgImage) {
        style['background-image'] =
          'url("' + content.canvas.style.bgImage + '")';
        style['background-repeat'] = 'no-repeat';
      }

      if (content.canvas.style.bgImage && !content.canvas.style.bg && !content.canvas.style.bgGradient) {
        style['--ys-step-bg'] = 'none';
      }
      else if(content.canvas.style.bgGradient){
        style['--ys-step-bg'] = this.buildGradientString(content.canvas.style.bgGradient);
      }

      if (content.canvas.style.bgImageSize) {
        style['background-size'] = content.canvas.style.bgImageSize;
      }
      if (content.canvas.style.bgImagePosition) {
        style['background-position'] = content.canvas.style.bgImagePosition;
      }

      if (!content.canvas.style.bgImage && scenarioStyle.bgImage) {
        style['background-image'] = 'url("' + scenarioStyle.bgImage + '")';
        style['background-repeat'] = 'no-repeat';

        if (scenarioStyle.bgImagePosition) {
          style['background-position'] = scenarioStyle.bgImagePosition;
        }

        if (scenarioStyle.bgImageSize) {
          style['background-size'] = scenarioStyle.bgImageSize;
        }
      }
    }
    return style;
  }

  // chart service?

  getChartDataSet(component: any, mode: string) {
    let labels = JSON.parse(JSON.stringify(component.chart.labels));
    let dataset = JSON.parse(JSON.stringify(component.chart.data));

    if (component.chart.type != 'bar' && component.chart.type != 'line') {
      dataset[0].borderColor = [
        '#4dc9f6',
        '#f67019',
        '#f53794',
        '#537bc4',
        '#acc236',
        '#166a8f',
        '#00a950',
        '#58595b',
        '#8549ba',
      ];
      dataset[0].backgroundColor = [
        '#4dc9f6',
        '#f67019',
        '#f53794',
        '#537bc4',
        '#acc236',
        '#166a8f',
        '#00a950',
        '#58595b',
        '#8549ba',
      ];
    }

    if (mode == 'player') {
      dataset[0].data.forEach((_var: any, _index: any) => {
        dataset[0].data[_index] = this.playerService.parseVars(_var);
      });
    }
    if (component.chart.type == 'bar') {
      dataset[0].borderWidth = 2;
    }
    if (component.chart.type == 'line') {
      dataset[0].pointRadius = 10;
      dataset[0].pointBackgroundColor = dataset[0].pointColor
        ? dataset[0].pointColor
        : dataset[0].backgroundColor;
      dataset[0].fill = component.chart.fillLine;
    }

    return {
      labels: labels,
      datasets: dataset,
    };
  }

  getChartOptions(component: any, scenario: any, mode?: any) {
    let fontFamily = 'Manrope';
    // fonts...
    if (component.style.font) {
      switch (component.style.font) {
        case 'body':
          fontFamily = scenario.style.fontFamily;
          break;
        case 'sans':
          fontFamily = scenario.style.fontSans;
          break;
        case 'serif':
          fontFamily = scenario.style.fontSerif;
          break;
        case 'heading':
          fontFamily = scenario.style.fontHeading;
          break;
        case 'mono':
          fontFamily = scenario.style.fontMono;
          break;
        case 'script':
          fontFamily = scenario.style.fontScript;
          break;
        case 'custom':
          fontFamily = component.style.fontFamily;
          break;
      }
    }
    let animations = true;
    if (mode == 'editor') {
      animations = false;
    }

    let chartOptions: any = {
      responsive: true,
      maintainAspectRatio: false,
      animation: animations,
      devicePixelRatio: 4,

      plugins: {
        legend: {
          labels: {
            font: {
              size: 14,
              family: fontFamily,
            },
          },
          display: component.chart.showLegend,
        },
        tooltip: {
          titleFont: {
            size: 14,
            family: fontFamily,
          },
          bodyFont: {
            size: 14,
            family: fontFamily,
          },
        },
      },
    };

    if (component.chart.type == 'bar' || component.chart.type == 'line') {
      chartOptions.scales = {
        y: {
          title: {
            display: true,
            text: component.chart.yLabel,
            font: {
              size: 14,
              family: fontFamily,
            },
          },
          ticks: {
            font: {
              size: 14,
              family: fontFamily,
            },
          },
          grid: {
            display:
              component.chart.showYGrid == undefined
                ? false
                : component.chart.showYGrid,
          },
        },
        x: {
          title: {
            display: true,
            text: component.chart.xLabel,
            font: {
              size: 14,
              family: fontFamily,
            },
          },
          ticks: {
            font: {
              size: 14,
              family: fontFamily,
            },
          },
          grid: {
            display:
              component.chart.showXGrid == undefined
                ? false
                : component.chart.showXGrid,
          },
        },
      };
    }

    return chartOptions;
  }

  checkChoice(choice: any) {
    let hidden = false;
    if (choice.config) {
      if (choice.config.showWhen) {
        // try it here
      } else if (choice.config.hidden) {
        hidden = true;
      }
    }

    return hidden;
  }

  parseVarsQuill(value: string, variables: any) {
    // get the scenario vars?
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(value, 'text/html');

    // find the vars
    const mentions = htmlDoc.querySelectorAll('span.mention');
    mentions.forEach((mention) => {
      let variableVar = '';
      if (mention.attributes.getNamedItem('data-value')) {
        let _var = mention.attributes.getNamedItem('data-value')?.value;
        variableVar = this.getVarValueByName(_var, variables);
      }
      mention.innerHTML = variableVar;
    });

    return htmlDoc.documentElement.innerHTML;
  }

  getVarValueByName(name: any, variables: Array<any>): string {
    let value = '';
    if (variables) {
      variables.forEach((_var) => {
        if (_var.name == name) {
          value = _var.value;
        }
      });
    }
    return value;
  }

  getImageCropStyle(component: any) {
    let style: any = {};

    //style['width'] = component.width;
    //style['height'] = component.height;
    let componentStyle = JSON.parse(JSON.stringify(component.style));
    let componentStyleDefaults = JSON.parse(JSON.stringify(component.style));

    let currentState;
    let statesObject = component;

    // determine the current state
    currentState = this.statesService.getComponentState(statesObject);

    if (component.currentState && !currentState) {
      currentState = this.getCurrentStateFromId(
        component,
        component.currentState
      );
    }

    // don't apply the state to a choices block
    if (currentState) {
      for (const [key, value] of Object.entries(currentState['style'])) {
        componentStyle[key] = value;
      }
    }

    if (componentStyle.imageCrop) {
      if (componentStyle.imageCrop.w) {
        style.width = componentStyle.imageCrop.w;
      }
      if (componentStyle.imageCrop.h) {
        style.height = componentStyle.imageCrop.h;
      }

      let transforms: any = {};
      // let el = document.getElementById('image-crop-' + component.id);
      // transforms = this.parseTransform(el!.style.transform);

      if (componentStyle.imageCrop.x) {
        transforms.translateX = componentStyle.imageCrop.x + 'px';
        //style.left = componentStyle.imageCrop.x + 'px';
      }
      if (componentStyle.imageCrop.y) {
        transforms.translateY = componentStyle.imageCrop.y + 'px';
        //style.top = componentStyle.imageCrop.y + 'px';
      }

      if (componentStyle.imageCrop.flip) {
        if (componentStyle.imageCrop.flip.h) {
          transforms.scaleX = '-1';
        } else {
          transforms.scaleX = null;
        }
        if (componentStyle.imageCrop.flip.v) {
          transforms.scaleY = '-1';
        } else {
          transforms.scaleY = null;
        }
      }

      let transformString = '';
      Object.keys(transforms).forEach(function (key, index) {
        if (transforms[key]) {
          transformString += key + '(' + transforms[key] + ') ';
        }
      });
      if (transformString != '') {
        style.transform = transformString;
      }
    }
    if (componentStyle?.imageCrop?.filter) {
      //console.log('filter!');
      let filter = '';
      // this.contentService.parseFilters();
      for (var prop in componentStyle.imageCrop.filter) {
        if (
          Object.prototype.hasOwnProperty.call(
            componentStyle.imageCrop.filter,
            prop
          ) &&
          componentStyle.imageCrop.filter[prop] != 0 &&
          componentStyle.imageCrop.filter[prop] != null
        ) {
          filter +=
            prop +
            '(' +
            ('' + componentStyle.imageCrop.filter[prop]) +
            this.getFilterUnit(prop) +
            ') ';
        }
      }
      if (filter) {
        style.filter = filter;
      }
    }

    //if(component.style.imageCrop.clip){
    // style.clipPath = component.style.imageCrop.clip;
    //}

    return style;
  }
  parseTransform(transform: string) {
    return Array.from(transform.matchAll(/(\w+)\((.+?)\)/gm)).reduce(
      (agg, [, fn, val]) => ({
        ...agg,
        [fn]: val,
      }),
      {}
    );
  }

  getFilterUnit(filterId: string) {
    let unit = '';
    environment.filters.forEach((filter: any) => {
      if (filter.id == filterId) {
        unit = filter.unit;
      }
    });
    return unit;
  }

  getBlockStyle(component: any, content: any, mode?: string) {
    let style: any = {};
    let blockComponent: any;
    content.components.forEach((contentComponent: any) => {
      if (contentComponent.type == 'block') {
        if (contentComponent.data.componentIds.indexOf(component.id) !== -1) {
          blockComponent = contentComponent;
        }
      }
    });

    if (blockComponent && blockComponent.style.rotate) {
      // get the middle of this component
      let xBlockMiddle = 0;
      let yBlockMiddle = 0;

      if (!blockComponent.drag.x && !blockComponent.drag.y) {
        xBlockMiddle = blockComponent.pos.x + blockComponent.width / 2;
        yBlockMiddle = blockComponent.pos.y + blockComponent.height / 2;
      } else {
        xBlockMiddle = blockComponent.drag.x + blockComponent.width / 2;
        yBlockMiddle = blockComponent.drag.y + blockComponent.height / 2;
      }

      let xComponentMiddle = component.pos.x + component.width / 2;
      let yComponentMiddle = component.pos.y + component.height / 2;

      style['transform'] = 'rotate(' + blockComponent.style.rotate + 'deg)';
      style['transform-origin'] =
        ' calc(' +
        component.width / 2 +
        'px + ' +
        (xBlockMiddle - xComponentMiddle) +
        'px)  calc(' +
        component.height / 2 +
        'px + ' +
        (yBlockMiddle - yComponentMiddle) +
        'px)';
      //  'transform:rotate(' + blockComponent.style.rotate + 'deg);'
      // +'transform-origin: calc(50% + ' + (xBlockMiddle - xComponentMiddle ) + 'px)  calc(50% + ' +  (yBlockMiddle - yComponentMiddle) + 'px);'
    }

    if (blockComponent && blockComponent.animationIn) {
      style['--animate-duration'] = blockComponent.animationIn.speed + 's';
      style['--animate-delay'] = blockComponent.animationIn.delay + 's';

      if (blockComponent.animationIn.repeat) {
        if (blockComponent.animationIn.repeat !== 'infinite') {
          style['--animate-repeat'] = +blockComponent.animationIn.repeat;
        }
      }
    }

    if (blockComponent && blockComponent.style.opacity != undefined) {
      style['opacity'] = blockComponent.style.opacity + '%';
    }

    if (blockComponent && blockComponent.style.blur != undefined) {
      style['filter'] = 'blur(' + blockComponent.style.blur + 'px)';
    }

    // does it need to have pointe events?
    /*if (mode == 'player') {
      let needsPointer = false;
      let pointerEvents = ['onPress', 'onHover'];
      blockComponent?.actions?.forEach((action: any) => {
        action?.events?.forEach((event: any) => {
          if (pointerEvents.indexOf(event.event) !== -1) {
            needsPointer = true;
          }
        });
      });
      if (!needsPointer) {
        style['pointer-events'] = 'none';
      }
    }*/
    return style;
  }

  getBlockClass(component: any, content: any) {
    return '';
  }

  getBlockAnimation(component: any, content: any) {
    let classStr: any = '';
    let blockComponent: any;
    content.components.forEach((contentComponent: any) => {
      if (contentComponent.type == 'block') {
        if (contentComponent.data.componentIds.indexOf(component.id) !== -1) {
          blockComponent = contentComponent;
        }
      }
    });

    if (blockComponent) {
      if (blockComponent.animationIn) {
        classStr +=
          ' animate__animated animate__delay-1s animate__' +
          blockComponent.animationIn.name;

        if (blockComponent.animationIn.repeat) {
          if (blockComponent.animationIn.repeat == 'infinite') {
            classStr += ' animate__infinite';
          } else {
            classStr += ' animate__repeat-1';
          }
        }
      }
    }

    return classStr;
  }

  stringify(object: object) {
    return JSON.stringify(object);
  }

  addAnimations(
    component: any,
    controlVarIn: any,
    controlVarDuring: any,
    controlVarOut: any,
    componentElem: any
  ) {
    if (component[controlVarIn] && component[controlVarIn].name) {
      component[controlVarIn].completed = false;
    }

    if (componentElem) {
      if (component[controlVarIn] && component[controlVarIn].name) {
        componentElem?.style?.setProperty(
          '--animate-duration',
          component[controlVarIn].speed + 's'
        );
        componentElem?.style?.setProperty(
          '--animate-delay',
          component[controlVarIn].delay + 's'
        );

        componentElem?.style?.setProperty(
          '--animate-repeat',
          component[controlVarIn].repeat
        );
      }

      componentElem.addEventListener('animationend', () => {
        if (
          component[controlVarIn] &&
          component[controlVarIn].name &&
          ((component[controlVarDuring] &&
            !componentElem?.classList.contains(
              'animate__' + component[controlVarDuring].name
            )) ||
            !component[controlVarDuring])
        ) {
          component[controlVarIn].completed = true;

          // remove the scenario level choice anim?

          if (component[controlVarIn].name) {
            componentElem?.classList.remove(
              'animate__' + component[controlVarIn].name
            );
            componentElem?.classList.remove('animate__infinite');
          }

          if (component[controlVarDuring] && component[controlVarDuring].name) {
            componentElem?.classList.add(
              'animate__' + component[controlVarDuring].name
            );
            componentElem?.style?.setProperty(
              '--animate-duration',
              component[controlVarDuring].speed + 's'
            );
            componentElem?.style?.setProperty(
              '--animate-delay',
              component[controlVarDuring].delay + 's'
            );

            componentElem?.style?.setProperty(
              '--animate-repeat',
              component[controlVarDuring].repeat
            );
          }
        }
      });

      if (component[controlVarOut] && component[controlVarOut].name) {
        var actionTimeout = setTimeout(() => {
          componentElem?.classList.add(
            'animate__' + component[controlVarOut].name
          );
          componentElem?.style?.setProperty(
            '--animate-duration',
            component[controlVarOut].speed + 's'
          );

          componentElem?.style?.setProperty(
            '--animate-repeat',
            component[controlVarOut].repeat
          );
        }, component[controlVarOut].delay * 1000);
      }
    }
  }
  addEndAnimation() {}

  getCurrentStateFromId(component: any, stateId: any) {
    let currentState: any;
    component.states.forEach((state: any) => {
      if (state.id == stateId) {
        currentState = state;
      }
    });
    return currentState;
  }

  getImageClip(component: any) {
    let componentStyle = JSON.parse(JSON.stringify(component.style));

    let currentState;
    let statesObject = component;
    // determine the current state
    currentState = this.statesService.getComponentState(statesObject);

    if (component.currentState && !currentState) {
      currentState = this.getCurrentStateFromId(
        component,
        component.currentState
      );
    }
    if (currentState) {
      for (const [key, value] of Object.entries(currentState['style'])) {
        componentStyle[key] = value;
      }
    }

    return componentStyle?.imageCrop?.clip
      ? componentStyle?.imageCrop?.clip
      : null;
  }

  buildGradientString(gradientSettings: any) {
    let bgString = '';
    if (!gradientSettings?.settings) {
      return bgString;
    }

    switch (gradientSettings.settings.type) {
      default:
      case 'linear':
        bgString +=
          'linear-gradient(' + gradientSettings.settings.rotation + 'deg,';
        gradientSettings.colors
          .sort((a: any, b: any) => a.position - b.position)
          .forEach((color: any) => {
            bgString += color.color + ' ' + color.position + '%,';
          });
        bgString = bgString.substring(0, bgString.length - 1);
        bgString += ')';
        break;

      case 'radial':
        bgString += 'radial-gradient(circle,';
        gradientSettings.colors
          .sort((a: any, b: any) => a.position - b.position)
          .forEach((color: any) => {
            bgString += color.color + ' ' + color.position + '%,';
          });
        bgString = bgString.substring(0, bgString.length - 1);
        bgString += ')';
        break;
    }
    return bgString;
  }

  hasWindowBg(content: any, scenario: any) {
    let windowBg = false;
    if (
      (content?.canvas?.style?.bg ||
        content?.canvas?.style?.bgGradient ||
        content?.canvas?.style?.bgImage) &&
      content?.canvas?.style?.bgFit != 'step'
    ) {
      windowBg = true;
    }

    if (!windowBg) {
      if (
        (scenario?.style?.bgColor || scenario?.style?.bgImage) &&
        scenario?.style?.bgFit != 'step' &&
        content?.canvas?.style?.bgFit != 'step'
      ) {
        windowBg = true;
      }
    }

    return windowBg;
  }

  hasStepBg(content: any, scenario: any) {
    let stepBg = false;
    if (
      (content?.canvas?.style.bg ||
        content?.canvas?.style.bgGradient ||
        content?.canvas?.style.bgImage) &&
      content?.canvas?.style.bgFit == 'step' &&
      content?.canvas?.style.bgFit !== 'window'
    ) {
      stepBg = true;
    }
    if (!stepBg) {
      if (
        (scenario?.style?.bgColor || scenario?.style?.bgImage) &&
        scenario?.style?.bgFit == 'step' &&
        content?.canvas?.style.bgFit != 'step' &&
        !(
          content?.canvas?.style.bg ||
          content?.canvas?.style.bgGradient ||
          content?.canvas?.style.bgImage
        )
      ) {
        stepBg = true;
      }
    }

    return stepBg;
  }
}
